<template>
    <div class="admin-users">
        <h1>會員管理</h1>
        <!-- 搜尋區 -->
        <div class="search-box">
            <input type="text" v-model="keyword" placeholder="關鍵字 ID 信箱 名稱 電話" @keyup.enter="handleSearch" />
            <button @click="handleSearch">搜尋</button>
        </div>
        <!-- 分頁按鈕 -->
        <div class="pagination">
            <!-- 上一頁按鈕：若已是第 1 頁，就 disabled -->
            <button @click="prevPage" :disabled="page <= 1">上一頁</button>

            <!-- 顯示當前頁 / 總頁數 -->
            <span>
                第 {{ page }} 頁 / 共 {{ totalPages }} 頁
            </span>

            <!-- 下一頁按鈕：若已到最後一頁，就 disabled -->
            <button @click="nextPage" :disabled="page >= totalPages">下一頁</button>
        </div>
        <!-- 使用者清單表格 -->
        <div class="table-responsive">

            <table class="users-table">
                <thead>
                    <tr>
                        <th>會員編號</th>
                        <th>會員帳號</th>
                        <th>會員名稱</th>
                        <th>Email</th>
                        <th>電話</th>
                        <th>建立時間</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.user_id">
                        <td>{{ user.user_id }}</td>
                        <td>
                            <span v-if="user.facebook_id">
                                是 FaceBook 登入
                            </span>
                            <span v-else-if="user.google_id">
                                是 Google 登入
                            </span>
                            <span v-else-if="user.line_user_id">
                                是 Line 登入
                            </span>
                            <span v-else>
                                {{ user.account }}
                            </span>
                        </td>
                        <td>{{ user.username }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.phone }}</td>
                        <td>{{ user.created_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'

export default {
    name: "AdminUsersPage",
    data() {
        return {
            users: [],       // 當前頁的使用者清單
            keyword: '',     // 搜尋關鍵字
            limit: 20,       // 每頁筆數
            offset: 0,       // 從哪一筆開始 (配合 limit 做分頁)
            page: 1,         // 當前頁碼
            total: 0,        // 後端回傳的「總筆數」
            totalPages: 1    // 總頁數 (由 total / limit 計算)
        }
    },
    async beforeCreate() {
        // 檢查是否登入
        const useAdminSysTemp = useAdminSysTempStore()
        await useAdminSysTemp.fetchAdminCheckLogin()
        if (!useAdminSysTemp.isLoggedIn) {
            this.$router.push('/admin/login')
        }
    },
    methods: {
        // 取得使用者列表
        async fetchUsers() {
            try {
                const { data } = await axios.post('/api/admin/getUsersByPage', {
                    limit: this.limit,
                    offset: this.offset,
                    keyword: this.keyword
                })
                if (data.success) {
                    this.users = data.users
                    // 後端回傳 total，用於計算總頁數
                    this.total = data.total
                    this.totalPages = Math.ceil(this.total / this.limit) || 1
                } else {
                    console.error(data.message)
                }
            } catch (err) {
                console.error('取得會員資料失敗:', err)
            }
        },

        // 點擊搜尋按鈕 -> 重設分頁，重新查詢
        handleSearch() {
            this.page = 1
            this.offset = 0
            this.fetchUsers()
        },

        // 下一頁
        nextPage() {
            // 若本頁的 users.length < limit，代表已經是最後一頁
            if (this.users.length < this.limit) return
            this.page++
            this.offset += this.limit
            this.fetchUsers()
        },

        // 上一頁
        prevPage() {
            this.page--
            this.offset -= this.limit
            this.fetchUsers()
        }
    },
    // 元件載入後，自動查詢一次
    mounted() {
        this.fetchUsers()
    }
}
</script>

<style scoped>

.search-box button {
    background-color: #2e3a59;
    color: #fff;
    border: none;
    padding: 0.4rem 1rem;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
    margin-top: auto;
}

.search-box button:hover {
    background-color: #3b4b6b;
}

.admin-users {
    background-color: #fafafa;
    padding: 1rem;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.search-box {
    margin-bottom: 1rem;
}

.users-table {
    min-width: 1200px;
    border-collapse: collapse;
    margin-bottom: 1rem;
    width: 100%;
}

.users-table th,
.users-table td {
    border: 1px solid #ccc;
    padding: 0.5rem;
    text-align: left;
}

.pagination {
    display: flex;
    gap: 1rem;
    align-items: center;
}

/* 讓表格在手機版可左右滑動 */
.table-responsive {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.users-table td {
    font-size: 18px;
}

.users-table th{
    font-size: 20px;
}

.pagination {
  margin-bottom: 1.5rem;  /* 與下方留1.5rem空白，可依需求調整 */
}

.search-box {
  display: flex;
  gap: 0.5rem; /* 輸入框跟按鈕之間的左右間距 */
  /* 若想要置中或靠左/靠右可再加 justify-content, etc. */
}

/* 分頁區域 */
.pagination {
    display: flex;
    align-items: center;
    gap: 1rem;
    justify-content: center;
}

.pagination button {
    background-color: #2e3a59;
    color: #fff;
    border: none;
    padding: 0.4rem 1rem;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
}


/* 手機 RWD */
@media (max-width: 768px) {

    /* 讓表格在手機版可左右滑動 */
    .table-responsive {
        max-width: 310px;
    } 
    .search-box {
        flex-direction: column; /* 讓按鈕自動換行到輸入框下方 */
        align-items: flex-start; /* 若需要可讓子項目對齊左側 */
    }
}



</style>